import React, { useState, useEffect } from 'react';
import { getCommitsInDateRangForDevelopersFromDB } from '../../../services/apiServices';
import CommitLineChart from './CommitLineChart';
import CommitBarChart from './CommitBarChart';
import SearchForm from '../../common/SearchForm';
import { Container, Modal, Row, Col, Spinner } from 'react-bootstrap';
const CommitHistoryChart = () => {
    const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
    const currDay = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(firstDay);
    const [endDate, setEndDate] = useState(currDay);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [commitData, setCommitData] = useState([]);


    useEffect(() => {
        const getcommitData = async () => {
            let allCommitsDetails = await getCommitsInDateRangForDevelopersFromDB({
                platform: formData.platform,
                selectedRepositoryId: formData.selectedRepositoryId,
                selectedDeveloperNames: formData.selectedDeveloperNames,
                startDate: formData.startDate,
                endDate: formData.endDate
            });
            setCommitData(allCommitsDetails)
        }
        if (formData && (formData?.selectedDeveloperNames.length > 0) && (formData.selectedRepositoryId.length > 0)) {
            getcommitData();
        }
        setShowModal(false);
    }, [formData]);

    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <Container fluid>
                <SearchForm
                    setFormData={setFormData}
                    setShowModal={setShowModal}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <Row style={{ paddingTop: 8, paddingInline: 12, paddingBottom: 20 }}>
                    <Col xs={12} style={{ marginBottom: 24 }}>
                        <CommitLineChart data={commitData} />
                    </Col>
                    <Col xs={12}>
                        <CommitBarChart data={commitData} />
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body className='modal-body-wrapper'>
                    <Spinner animation="border" variant="warning" />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CommitHistoryChart;